import React from 'react'

const NotFoundPage = () => {
    return (
        <div className='h-screen flex justify-center items-center'>
            <h1 className='text-3xl font-semibold text-center'>Error 404 - Page Not Found</h1>
        </div>
    )
}

export default NotFoundPage
